import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { APP_NAME } from '@zet/end-points'
import { zetApi } from '@zet/network'

import { IAppComms } from './types'

export async function getAppComms() {
  const { data } = await zetApi.get<IAppComms>(`getBrandComms/v6?partnerId=0`, {
    method: 'GET',
    headers: {
      ...(APP_NAME === MY_TEAMS_ADVISOR ? { appSource: 'bridge' } : {}),
    },
  })
  let content = {}
  if (data?.data?.content) {
    content = JSON.parse(data?.data?.content)
  }
  return content
}
